module.exports = __webpack_public_path__ + "media/images/values/selfless-81da31adca5899bbc484ccbcb6efbd2e.svg";